import {
  BO_TREND_REPORT,
  GRAPH_DATA_DIVISION_DEPT,
  VENDOR_TABLE,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";
import { downloadExcelFromLink } from "../../utility/excel";

export const getGraphDataDevDept = (
  startDate,
  endDate,
  duration,
  division,
  department,
  vendor,
  location,
  page,
  limit
) => {
  const requestURL = GRAPH_DATA_DIVISION_DEPT;
  let obj = { from_date: startDate, to_date: endDate, duration: duration };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }
  
  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getVendorTableData = (
  startDate,
  endDate,
  duration,
  division,
  department,
  vendor,
  location,
  page,
  limit,
  sort
) => {
  const requestURL = VENDOR_TABLE;
  let obj = { from_date: startDate, to_date: endDate, duration: duration, sort_order: sort };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const boTrendReport = (
  startDate,
  endDate,
  division,
  department,
  vendor,
  location
) => {
  const requestURL = BO_TREND_REPORT;
  let obj = { from_date: startDate, to_date: endDate };

  if (division && division.length) {
    obj["division_list"] = division.join(",");
  }

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  if (vendor && vendor.length) {
    obj["vendor_list"] = vendor.join(",");
  }

  if (location && location.length) {
    obj["location_list"] = location.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const fileDownload = () =>{
  const requestURL = "https://msil-spares-pricing-recommendation-dev-lz.s3.amazonaws.com/di.csv?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAZR3MOFXMN2L7DQC5%2F20240202%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20240202T131436Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEJL%2F%2F%2F%2F%2F%2F%2F%2F%2F%2FwEaCmFwLXNvdXRoLTEiSDBGAiEAwRChBx%2BDf8cLpGdm2bd195mfzCFZcZdqtuFgoTBnqsUCIQD4XU4oqDchQNwPkQVSk33CuZkkbLP0ZAutGNo4Ul761Cq%2FBQhbEAAaDDY1NjgyMDU0NzAzMiIMST%2Fg%2BEXMGCQGXvAWKpwFQ4a2C7MvIS9pIU9EoQJpfsdaRM2C2CuIXycfFDzntXMkUPYk6tSimcDGnVgJDiAOGJsmreUd1l38rDTy6sgLv3kUouLfkh%2FTJx7vExgn43XxEahZKdjadsToABxjXBugiBgR%2Bw2aC%2FWjwLA73vjAQsCDprOVecY6gt%2BBB%2Fjv7EsjZstgMe12HpOYkA9Yb5CKRDyrb12aGEXixi6QEeMeReJWFpBiZDp412NZvERketMw1Xwj5pzys0mwUOsIA2tm2guuW35%2FiKH9iQNmC3mlWGSc7ko56aj%2Beqaxg%2FogwWCo7NtIL8G%2Ftf3m%2Fm5%2BW%2Bp0eSnRfqPqKQbsgpuIMiBFkvjtKfiIdXrODm3MdYFsnjMucE%2FUsvaoG1wW6LPVIgCcUMjQtQc89cE9X%2BFjrdSHZMW4RgVcrSIos9W8%2B27A8uvNbOjF1ZJyJfqzEVnBEKcgcfYCrCggcq0R12YcZOvoqtfWxp33j%2FsXZeO1UnoxUucKcRuX9Z7ta0CSbjgpuDyQ0S2giPQyRLqHsJejX%2FyF5zKTp6%2Bcd4fVGVw79m9iqNud1RhwSsMuBjpzIp3H73nTFzxfs9d76phnkMz1zlb2YVJ%2BjSbu%2Fyi33eEBmuWXZajLzi4z5z0mEhLLmPLtFOD8KWDYqTf7QMxsMvg5C8hZTL2hv1e1Yzgn%2B0wfeJsw%2BY0CzPUTQgjTQug1iDtByFuUG1OT6xeXGy6%2FjG1FB3pCyvzEMm6akH3bPTHZBm6rjw%2BXOy6mkuD9md%2BSHVrSA%2BZ8VHs5D46nDm8kCMmiFq3G8otsbscm61OZzd7lqv0yBjX6eU%2FT8uvfN8tiCFjzk4KKlUEfxXu%2F1vv9P6xLVcwIAM2I8CPYix0BNtPfn7DlpnS7LMnMJdHdsKb2JEAw2u3yrQY6sAHNAQTO4ojWgwQvf8bHKxgEQtJ%2Bb77ll%2BJIvximc%2BWYkEiJsYjTkk0fn2rvwwO3KeGpl5t56krImuPGCOmcnoEF5BEsMS1%2FppJOBdI3CwYHXJaU9l8H4At1q2D0B0ycbi6MqulOUbM6SP7PQ8RGf839AS7A4T5b5VRLGIMz%2BZ299TdTFjlrosda6Nkjsor%2BNg5D6T6EhA%2FzcWCoueAFfrA2VUUZn6a0esUBNmRLif4uBQ%3D%3D&X-Amz-Signature=c327dac2d15e3ed508c357aeba22a7a35fd76ad7741dfa0cce23682c46ae1d6d";

  downloadExcelFromLink(requestURL, "ABC.csv")
}